module.exports = __webpack_public_path__ + "static/reason_driven-d83dc8e42f3a5c94e052ae9ef123ef62.png";